//
//
//
//
//
//
//
//
//
//
//
//

import { Native } from '@hb/hbridge';
import config from '@/const/config';
import TQ from '@/utils/tianqi';
import { Button as HButton, MediaList } from '../common';

export default {
  components: { HButton, MediaList },
  props: {
    data: {
      type: Object,
      default: (() => {}),
    }
  },
  methods: {
    success() {
      return true;
    },
    async clickHandle() {
      TQ.clickButton({
        pageId: 'usergrowth_power_alipay',
        buttonName: 'mainbutton_click_usergrowth',
        categoryId: 'switchpower',
        businessInfo: {
          citytype: this.$store.state.user.tianqiParams.citytype,
          title: this.data.redirectText
        }
      });
      await Native.callNative({
        method: 'navigateToMiniProgram',
        params: {
          appId: config.aliAppId,
          path: '',
          extraData: '',
        }
      });
    }
  },
};
